var AchivementProgressComponent = (function () {
    function AchivementProgressComponent() {
    }
    AchivementProgressComponent.prototype.ngAfterViewInit = function () { };
    return AchivementProgressComponent;
}());
export { AchivementProgressComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/achievement/components/progressBar/progress-bar.component.ts.pre-build-optimizer.js